import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import FrontLoader from "../layout/FrontLoader";
import { Routes as AppRoutes } from "../../constants/RouteConstants";
import { decodeID } from "../../utils/Helper";
import { openPdfUrlInNewBrowserTab } from "../../utils/openQuotationPdf";
import "../myquotation/QuotationPdfPreview.scss";

/** Legacy route: fetch order PDF and open it in a new tab, then return to order details. */
function OrderPdfPreview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const orderPdf = useMakeRequest();
  const [opening, setOpening] = useState(false);
  const triggeredRef = useRef(false);
  const openedRef = useRef(false);

  const goBack = () => {
    if (id) navigate(AppRoutes.OrderDetail.replace(":id", String(id)));
    else navigate(AppRoutes.Order);
  };

  useEffect(() => {
    triggeredRef.current = false;
    openedRef.current = false;
    setOpening(false);
  }, [id]);

  useEffect(() => {
    if (!id || triggeredRef.current) return;
    const decodedOrderId = decodeID(decodeURIComponent(String(id)));
    if (!decodedOrderId) {
      toast.error("Could not load PDF.");
      goBack();
      return;
    }
    triggeredRef.current = true;
    orderPdf.makeRequest({
      payload: { type: "order", order_id: decodedOrderId },
      url: ApiConstants?.QuotesPdf,
      toastStatus: false,
    });
  }, [id]);

  useEffect(() => {
    if (!orderPdf?.status || openedRef.current) return;
    const d = orderPdf?.data?.data as
      | { PDF_URL?: string; order_id?: string | number; quotation_id?: string | number }
      | undefined;
    const pdfUrl = d?.PDF_URL;
    if (!pdfUrl) {
      toast.error("Could not load PDF.");
      goBack();
      return;
    }

    openedRef.current = true;
    setOpening(true);
    openPdfUrlInNewBrowserTab(pdfUrl);
    setOpening(false);
    goBack();
  }, [orderPdf?.status, id]);

  return (
    <main className="quotation-pdf-preview">
      {(orderPdf.loading || opening) && <FrontLoader />}
    </main>
  );
}

export default OrderPdfPreview;
